export default __webpack_public_path__ + "images/SJB.6c0df66.png";